import { enUS, th, km, vi, zhCN, type Locale } from 'date-fns/locale';

/**
 * Maps an i18next language tag to a date-fns Locale.
 *
 * date-fns ships locales for en/th/km/vi/zh but NOT Lao (lo) or Burmese (my),
 * so those fall back to enUS for absolute date/time formatting. Duration and
 * unit labels do NOT use these — they come from react-i18next keys so all 7
 * languages are fully covered (see formatDurationShort in ./duration.ts).
 */
const MAP: Record<string, Locale> = {
  en: enUS,
  th,
  km,
  vi,
  zh: zhCN,
};

export function dateFnsLocale(lang: string | undefined): Locale {
  const base = (lang ?? 'en').split('-')[0]!;
  return MAP[base] ?? enUS;
}
